'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchConsoleBrandingIfNeeded = exports.isConsoleBrandingSellerLoading = exports.isConsoleBrandingCatalogLoading = exports.getConsoleBranding = exports.LOAD_CONSOLE_BRANDING_SUCCESS = exports.LOAD_CONSOLE_BRANDING_REQUEST = exports.LOAD_CONSOLE_BRANDING_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('./config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CONSOLE_BRANDING_FAIL = exports.LOAD_CONSOLE_BRANDING_FAIL = 'la/domain/consoleBranding/LOAD_FAIL';
var LOAD_CONSOLE_BRANDING_REQUEST = exports.LOAD_CONSOLE_BRANDING_REQUEST = 'la/domain/consoleBranding/LOAD_REQUEST';
var LOAD_CONSOLE_BRANDING_SUCCESS = exports.LOAD_CONSOLE_BRANDING_SUCCESS = 'la/domain/consoleBranding/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byCatalogId: {},
    bySellerId: {},
    loadedCatalogs: {},
    loadedSellers: {},
    loadingCatalogs: [],
    loadingSellers: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existingCatalogs = void 0;
    var existingSellers = void 0;
    var loadedCatalogs = void 0;
    var loadedSellers = void 0;
    var loadingCatalogs = void 0;
    var loadingSellers = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_CONSOLE_BRANDING_FAIL:
            return (0, _extends3.default)({}, state, {
                loadingCatalogs: (0, _difference2.default)(state.loadingCatalogs, action.payload.catalogId),
                loadingSellers: (0, _difference2.default)(state.loadingSellers, action.payload.sellerId)
            });
        case LOAD_CONSOLE_BRANDING_REQUEST:
            return (0, _extends3.default)({}, state, {
                loadingCatalogs: (0, _union2.default)(state.loadingCatalogs, action.payload.catalogId),
                loadingSellers: (0, _union2.default)(state.loadingSellers, action.payload.sellerId)
            });
        case LOAD_CONSOLE_BRANDING_SUCCESS:
            existingCatalogs = (0, _cloneDeep2.default)(state.byCatalogId);
            existingSellers = (0, _cloneDeep2.default)(state.bySellerId);
            loadedCatalogs = (0, _extends3.default)({}, state.loadedCatalogs);
            loadedSellers = (0, _extends3.default)({}, state.loadedSellers);
            loadingCatalogs = (0, _cloneDeep2.default)(state.loadingCatalogs);
            loadingSellers = (0, _cloneDeep2.default)(state.loadingSellers);
            time = action.meta.actionTime;

            if (action.payload.consoleBrandings) {
                action.payload.consoleBrandings.forEach(function (item) {
                    var catalogId = item.catalogId,
                        _item$color = item.color,
                        color = _item$color === undefined ? '' : _item$color,
                        _item$logoUrl = item.logoUrl,
                        logoUrl = _item$logoUrl === undefined ? '' : _item$logoUrl,
                        sellerId = item.sellerId;

                    // make sure that we're using a secure connection

                    if (logoUrl.includes('http://')) {
                        logoUrl = item.logoUrl.replace('http://', 'https://');
                    }

                    // convert to hex color style
                    if (color.includes('0x')) {
                        color = item.color.replace('0x', '#');
                    }

                    if (catalogId) {
                        existingCatalogs[catalogId] = (0, _extends3.default)({}, item, {
                            color: color,
                            logoUrl: logoUrl
                        });
                        loadedCatalogs[catalogId] = time;
                        loadingCatalogs = (0, _difference2.default)(loadingCatalogs, [catalogId]);
                    }
                    if (sellerId) {
                        existingSellers[sellerId] = (0, _extends3.default)({}, item, {
                            color: color,
                            logoUrl: logoUrl
                        });
                        loadedSellers[sellerId] = time;
                        loadingSellers = (0, _difference2.default)(loadingSellers, [sellerId]);
                    }
                });
            }
            return (0, _extends3.default)({}, state, {
                byCatalogId: existingCatalogs,
                bySellerId: existingSellers,
                loadedCatalogs: loadedCatalogs,
                loadedSellers: loadedSellers,
                loadingCatalogs: loadingCatalogs,
                loadingSellers: loadingSellers
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.consoleBranding;
};
var catalogIdSelector = function catalogIdSelector(state, catalogId) {
    return catalogId;
};
var sellerIdSelector = function sellerIdSelector(state, catalogId, sellerId) {
    return sellerId;
};

var byCatalogIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byCatalogId;
});
var bySellerIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.bySellerId;
});

var loadedCatalogsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loadedCatalogs;
});
var loadedSellersSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loadedSellers;
});

var loadingCatalogsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loadingCatalogs;
});
var loadingSellersSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loadingSellers;
});

var getConsoleBrandingCatalog = (0, _reselect.createSelector)([byCatalogIdSelector, catalogIdSelector], function (byId, catalogId) {
    return byId[catalogId] || { color: '', logoUrl: '' };
});

var getConsoleBrandingSeller = (0, _reselect.createSelector)([bySellerIdSelector, sellerIdSelector], function (byId, sellerId) {
    return byId[sellerId] || { color: '', logoUrl: '' };
});

var getConsoleBranding = exports.getConsoleBranding = (0, _reselect.createSelector)([getConsoleBrandingCatalog, getConsoleBrandingSeller], function (catalog, seller) {
    if (catalog.color !== '' || catalog.logoUrl !== '') {
        return catalog;
    } else if (seller.color !== '' || seller.logoUrl !== '') {
        return seller;
    } else {
        return {
            color: '',
            logoUrl: ''
        };
    }
});

var getLoadTimeForConsoleBrandingCatalog = (0, _reselect.createSelector)([loadedCatalogsSelector, catalogIdSelector], function (loaded, id) {
    return loaded[id] || 0;
});
var getLoadTimeForConsoleBrandingSeller = (0, _reselect.createSelector)([loadedSellersSelector, sellerIdSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isConsoleBrandingCatalogLoading = exports.isConsoleBrandingCatalogLoading = (0, _reselect.createSelector)([loadingCatalogsSelector, catalogIdSelector], function (loading, id) {
    return loading.includes(id);
});
var isConsoleBrandingSellerLoading = exports.isConsoleBrandingSellerLoading = (0, _reselect.createSelector)([loadingSellersSelector, sellerIdSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchConsoleBrandingCatalog = function shouldFetchConsoleBrandingCatalog(state, catalogId) {
    if (!catalogId) return false;
    var loaded = getLoadTimeForConsoleBrandingCatalog(state, catalogId);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;

    var loading = isConsoleBrandingCatalogLoading(state, catalogId);
    return !loading;
};

var shouldFetchConsoleBrandingSeller = function shouldFetchConsoleBrandingSeller(state, catalogId, sellerId) {
    if (!sellerId) return false;
    var loaded = getLoadTimeForConsoleBrandingSeller(state, catalogId, sellerId);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;

    var loading = isConsoleBrandingSellerLoading(state, catalogId, sellerId);
    return !loading;
};

var shouldFetchConsoleBranding = function shouldFetchConsoleBranding(state, catalogId, sellerId) {
    return shouldFetchConsoleBrandingCatalog(state, catalogId) || shouldFetchConsoleBrandingSeller(state, catalogId, sellerId);
};

/* ACTION CREATORS */
var loadConsoleBranding = function loadConsoleBranding(catalogId, sellerId) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            payload: { catalogId: catalogId, sellerId: sellerId },
            type: LOAD_CONSOLE_BRANDING_REQUEST
        });
        return _api.ConsoleBranding.fetchConsoleBranding({ catalogId: catalogId, deployment: deployment, sellerId: sellerId }).then(function (response) {
            dispatch({
                meta: { actionTime: Date.now(), catalogId: catalogId, sellerId: sellerId },
                payload: response.data,
                type: LOAD_CONSOLE_BRANDING_SUCCESS
            });
        }).catch(function (error) {
            dispatch({
                error: true,
                meta: { catalogId: catalogId, sellerId: sellerId },
                payload: error,
                type: LOAD_CONSOLE_BRANDING_FAIL
            });
        });
    };
};

var fetchConsoleBrandingIfNeeded = exports.fetchConsoleBrandingIfNeeded = function fetchConsoleBrandingIfNeeded(catalogId, sellerId) {
    return function (dispatch, getState) {
        var needed = shouldFetchConsoleBranding(getState(), catalogId, sellerId);
        if (needed) {
            return dispatch(loadConsoleBranding(catalogId, sellerId));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/consoleBranding.js
// module id = TqJy
// module chunks = 60